/**
 * Gemeinsame Popper-Einstellungen für alle Tooltips des Bereichs Cosmos
 * (Rückmeldung T13: ein Tooltip darf nie oben aus dem Browserfenster
 * herauslaufen). "flip" dreht die Platzierung um, wenn am bevorzugten Rand
 * kein Platz ist, "preventOverflow" mit altAxis schiebt den Tooltip
 * zusätzlich seitlich zurück in den sichtbaren Bereich - beide mit 8px
 * Sicherheitsabstand zum Fensterrand.
 */
export const TOOLTIP_POPPER_CONFIG = {
    modifiers: [
        {name: "flip", options: {fallbackPlacements: ["bottom", "top", "right", "left"], padding: 8}},
        {name: "preventOverflow", options: {boundary: "viewport", padding: 8, altAxis: true}},
    ],
};
